export const PlatformOptionConst = [
    {
        icon: 'icon_wa',
        inputSvgIcon: 'icon-wa-gray',
        image: 'whatsapp.png',
        label: 'WhatsApp',
        value: 'WA',
    },
    {
        icon: 'menu_sms',
        inputSvgIcon: 'icon-sms-gray',
        image: 'sms.png',
        label: 'SMS',
        value: 'SMS',
    },
    {
        icon: 'icon_email',
        inputSvgIcon: 'icon-email-gray',
        image: 'email-contact.png',
        label: 'Email',
        value: 'EMAIL',
    },
    {
        icon: 'icon_line',
        inputSvgIcon: 'icon-line-gray',
        image: 'line.png',
        label: 'Line',
        value: 'LINE',
    },
];

export const MsgTypeWAOptionConst = [
    {
        name: 'Text',
        code: 'TEXT',
    },
    {
        name: 'Media',
        code: 'MEDIA',
    },
    {
        name: 'Template',
        code: 'TEMPLATE',
    },
    {
        name: 'Text - Utility',
        code: 'utility',
    },
    /* {
		name: 'Catalogue',
		code: 'CATALOGUE',
	}, */
];

export const MsgTypeEmailOptionConst = [
    {
        name: 'Text',
        code: 'HTML',
    },
    {
        name: 'Template',
        code: 'TEMPLATE',
    },
];

export const MsgTypeLineOptionConst = [
    {
        name: 'Text',
        code: 'TEXT',
    },
    {
        name: 'Template',
        code: 'TEMPLATE',
    },
    /* {
		name: 'Button',
		code: 'BUTTON',
	},
	{
		name: 'Confirmation',
		code: 'CONFIRMATION',
	},
	{
		name: 'Carousel',
		code: 'CAROUSEL',
	},
	{
		name: 'Image Carousel',
		code: 'IMAGE_CAROUSEL',
	},
	{
		name: 'Flex Bubble',
		code: 'FLEX_BUBBLE',
	},
	{
		name: 'Flex Carousel',
		code: 'FLEX_CAROUSEL',
	}, */
];

export const MediaTypeOptionConst = [
    {
        name: 'Image',
        code: 'IMAGE',
    },
    {
        name: 'Video',
        code: 'VIDEO',
    },
    {
        name: 'Document',
        code: 'DOCUMENT',
    },
    /* {
		name: 'Location',
		code: 'LOCATION',
	}, */
];

export const WidgetLiveCampaignConst: {
    title: string;
    arrow: string;
    value: number;
    date: string;
    icon: string;
    dateclass: string;
}[] = [
    {
        title: 'Total Campaigns',
        arrow: '../../../../assets/svg/icon-down-arrow.svg',
        value: 0,
        date: '',
        icon: '../../../../assets/svg/icon-total-campaign.svg',
        dateclass: 'redpercent',
    },
    {
        title: 'Live Campaigns',
        arrow: '../../../../assets/svg/icon-down-arrow.svg',
        value: 0,
        date: '',
        icon: '../../../../assets/svg/icon-use-campaign.svg',
        dateclass: 'redpercent',
    },
    {
        title: 'Pending Approval',
        arrow: '../../../../assets/svg/icon-down-arrow.svg',
        value: 0,
        date: '',
        icon: '../../../../assets/svg/icon-pending-approval-campaign.svg',
        dateclass: 'redpercent',
    },
];

export const CampaignPerformanceChartConfig = {
    legend: {
        icon: 'circle',
        orient: 'horizontal',
        x: 'center',
        y: 'bottom',
    },
    tooltip: {},
    dataset: {
        source: [['', 'WA Text', 'WA Template', 'WA Media', 'Product Catalog']],
    },
    xAxis: { type: 'category' },
    yAxis: {},
    series: [
        { type: 'bar', color: '#E666DA' },
        { type: 'bar', color: '#EB7215' },
        { type: 'bar', color: '#F3B435' },
        { type: 'bar', color: '#35CDF3' },
    ],
};

export const ConversationInsightsChartConfig = {
    tooltip: {
        trigger: 'axis',
    },
    legend: {
        icon: 'circle',
        data: ['Delivery Rate of Campaigns', 'Total Number of Campaigns', 'Cost Distribution'],
        x: 'center',
        y: 'bottom',
    },
    xAxis: {
        type: 'category',
        data: [],
    },
    yAxis: {
        type: 'value',
    },
    series: [
        {
            name: 'Delivery Rate of Campaigns',
            data: [],
            type: 'line',
            smooth: true,
            itemStyle: { normal: { color: 'blue' } },
        },
        {
            name: 'Total Number of Campaigns',
            data: [],
            type: 'line',
            smooth: true,
            itemStyle: { normal: { color: 'green' } },
        },
        {
            name: 'Cost Distribution',
            data: [],
            type: 'line',
            smooth: true,
            itemStyle: { normal: { color: '#E666DA' } },
        },
    ],
};
